import get_bin_config from './bin_config'
import getAwbs from './getAwbs'

const normalizeAwbNo = (awbNo = '') => awbNo.toString().replace(/-/g, '').trim()

const getScrubData = (flight, priorityData = []) => {
  let data = { ...flight } || {}
  let scrub_data = data?.scrub_data || {}
  let bin_config = get_bin_config(data)
  let mergeEditRecord = getAwbs(data, priorityData).mergeEditRecord
  const workarea = {}
  let sortedWorkareaKeys = []
  let awbs = []
  let icargo = data?.build_plan?.filter((awb) => awb?.icargo) || false
  // if (flight?.init_build_plan && data?.scrub_data) {
  if (data?.scrub_data) {
    sortedWorkareaKeys = Object.keys(scrub_data?.workareaData).sort((a, b) => {
      if (a === 'UNKNOWN') return 1
      if (b === 'UNKNOWN') return -1
      return a.localeCompare(b)
    })
    return {
      flightNo: data.flight_no || '',
      station: data.dest_stn || '',
      ...scrub_data,
      workarea: sortedWorkareaKeys,
    }
  }
  if (icargo.length == 0) {
    data.ulds_out?.map((uld) => {
      if (uld.blk) {
        uld.awbs_in.map((awb) => {
          let mergeRecord = mergeEditRecord.find((item) => item.awb_no === awb.awb_no?.replace(/-/g, ''))
          let build_Awb = flight.build_plan?.find((item) => item.awb_no === awb.awb_no)
          let builtUlds = build_Awb?.ulds && build_Awb?.ulds.length > 0 ? build_Awb.ulds.map((uld) => uld.uld_type + uld.uld_no).join(', ') : ''
          !workarea[uld.build_to || 'UNKNOWN'] && (workarea[uld.build_to || 'UNKNOWN'] = {})
          !workarea[uld.build_to || 'UNKNOWN']['loose'] && (workarea[uld.build_to || 'UNKNOWN']['loose'] = [])
          workarea[uld.build_to || 'UNKNOWN']['loose'].push({
            ...awb,
            piece_type: mergeRecord?.at_stn?.length > 1 ? 'partial' : 'loose',
            pri: mergeRecord?.pri || '',
            delay: mergeRecord?.delay || 0,
            sort_priority: mergeRecord?.sort_priority || null,
            prod_code: mergeRecord?.prod_code || '',
            builtUlds: builtUlds,
            yesNo: builtUlds !== '' ? 'Yes' : 'No',
            comments: builtUlds !== '' ? 'Built' : ''
          })
          awbs.push(awb.awb_no)
        })
      } else {
        !workarea[uld.build_to || 'UNKNOWN'] && (workarea[uld.build_to || 'UNKNOWN'] = {})
        !workarea[uld.build_to || 'UNKNOWN']['uld'] && (workarea[uld.build_to || 'UNKNOWN']['uld'] = [])
        let delays = []
        let pris = []
        let products = []
        uld.awbs_in.forEach((awb) => {
          let mergeRecord = mergeEditRecord.find((item) => item.awb_no === awb.awb_no?.replace(/-/g, ''))
          products.push(awb.prod_code)
          pris.push(mergeRecord?.pri || 999)
          delays.push(mergeRecord?.delay || 0)
          awbs.push(awb.awb_no)
        })
        let minDelay = Math.min(...delays)
        let minPri = Math.min(...pris)
        if (minPri === 999) {
          minPri = ''
        }
        products = [...new Set(products)]
        const productStr = products.join(', ')
        workarea[uld.build_to || 'UNKNOWN']['uld'].push({
          awb_no: uld.uld_no,
          location: uld.location,
          pri: minPri,
          delay: minDelay,
          prod_code: productStr,
          builtUlds: uld.uld_no || '',
          yesNo: uld.uld_no ? 'Yes' : 'No',
          comments: 'Built'
        })
      }
    })
  }
  mergeEditRecord?.map((awb) => {
    if (awb.awb_no && !awbs.includes(awb.awb_no)) {
      let build_Awb = flight.build_plan?.find((item) => item.awb_no === awb.awb_no)
      let builtUlds = build_Awb?.ulds && build_Awb?.ulds.length > 0 ? build_Awb.ulds.map((uld) => uld.uld_type + uld.uld_no).join(', ') : ''
      !workarea['UNKNOWN'] && (workarea['UNKNOWN'] = {})
      !workarea['UNKNOWN']['loose'] && (workarea['UNKNOWN']['loose'] = [])
      workarea['UNKNOWN']['loose'].push({
        awb_no: awb.awb_no,
        location: awb.location,
        pri: awb.pri,
        delay: awb.delay || 0,
        sort_priority: awb.sort_priority || null,
        prod_code: awb.prod_code,
        builtUlds: builtUlds,
        yesNo: builtUlds !== '' ? 'Yes' : 'No',
        comments: builtUlds !== '' ? 'Built' : ''
      })
      awbs.push(awb.awb_no)
    }
  })
  // sort loose and uld arrays by delay and priority
  Object.keys(workarea).forEach((i) => {
    const w = workarea[i]
    if (w.loose) {
      const seenLoose = new Set()
      w.loose = w.loose.filter((row) => {
        const key = normalizeAwbNo(row?.awb_no) + `|${(row?.location || '').toString().trim()}`
        if (!key || seenLoose.has(key)) return false
        seenLoose.add(key)
        return true
      })

      w.loose.sort((a, b) => {
        let a_delay = a?.delay ? a?.delay : 0
        let b_delay = b?.delay ? b?.delay : 0
        let a_priority = a.sort_priority || 999
        let b_priority = b.sort_priority || 999
        if (a.init && !b.init) return -1
        if (!a.init && b.init) return 1
        if (a_priority !== b_priority) {
          return a_priority - b_priority
        } else {
          return b_delay - a_delay
        }
      })
    }
    if (w.uld) {
      const seenUld = new Set()
      w.uld = w.uld.filter((row) => {
        const key = normalizeAwbNo(row?.awb_no) + `|${(row?.location || '').toString().trim()}`
        if (!row?.awb_no || seenUld.has(key)) return false
        seenUld.add(key)
        return true
      })

      w.uld.sort((a, b) => {
        let a_delay = a?.delay ? a?.delay : 0
        let b_delay = b?.delay ? b?.delay : 0
        let a_priority = a.sort_priority || 999
        let b_priority = b.sort_priority || 999
        if (a.init && !b.init) return -1
        if (!a.init && b.init) return 1
        if (a_priority !== b_priority) {
          return a_priority - b_priority
        } else {
          return b_delay - a_delay
        }
      })
    }
  })
  //sort Unknown to last
  sortedWorkareaKeys = Object.keys(workarea).sort((a, b) => {
    if (a === 'UNKNOWN') return 1
    if (b === 'UNKNOWN') return -1
    return a.localeCompare(b)
  })
  scrub_data?.workareaData && Object.keys(scrub_data?.workareaData).forEach((i) => {
    const w = scrub_data?.workareaData?.[i]
    if (workarea[i] && w) {
      if (workarea[i].loose && w.loose) {
        w.loose.map((row, index) => {
          let foundRow = workarea[i].loose.find((r) => r.awb_no === row.awb_no)
          if (foundRow) {
            workarea[i].loose[index] = {
              ...foundRow,
              yesNo: row.yesNo || '',
              builtUlds: row.builtUlds || '',
              comments: row.comments || ''
            }
          }
        })
      }
      if (workarea[i].uld && w.uld) {
        w.uld.map((row, index) => {
          let foundRow = workarea[i].uld.find((r) => r.awb_no === row.awb_no)
          if (foundRow) {
            workarea[i].uld[index] = {
              ...foundRow,
              yesNo: row.yesNo || '',
              builtUlds: row.builtUlds || '',
              comments: row.comments || ''
            }
          }
        })
      }
    }
  })

  // add final check to remove any duplicate awvb_no in workarea
  Object.keys(workarea).forEach((i) => {
    const w = workarea[i]
    if (w.loose) {
      const seenLoose = new Set()
      w.loose = w.loose.filter((row) => {
        const key = normalizeAwbNo(row?.awb_no) + `|${(row?.location || '').toString().trim()}`
        if (!key || seenLoose.has(key)) return false
        seenLoose.add(key)
        return true
      })
    }
    if (w.uld) {
      const seenUld = new Set()
      w.uld = w.uld.filter((row) => {
        const key = normalizeAwbNo(row?.awb_no) + `|${(row?.location || '').toString().trim()}`
        if (!key || seenUld.has(key)) return false
        seenUld.add(key)
        return true
      })
    }
  })

  return {
    flightNo: data.flight_no || '',
    station: data.dest_stn || '',
    maxConfig: {
      PMC: bin_config?.[0]?.PMC || 0,
      PAG: bin_config?.[0]?.PAG || 0,
      LD2: bin_config?.[0]?.LD2 || 0,
      LD3: bin_config?.[0]?.LD3 || 0,
      LD48FQA: scrub_data?.maxConfig?.LD48FQA || 0,
    },
    plannedConfig: {
      PMC: bin_config?.[1]?.PMC || 0,
      PAG: bin_config?.[1]?.PAG || 0,
      LD2: bin_config?.[1]?.LD2 || 0,
      LD3: bin_config?.[1]?.LD3 || 0,
      LD48FQA: scrub_data?.plannedConfig?.LD48FQA || 0,
    },
    finalConfig: data.finalConfig || {
      PMC: scrub_data?.finalConfig?.PMC || 0,
      PAG: scrub_data?.finalConfig?.PAG || 0,
      LD2: scrub_data?.finalConfig?.LD2 || 0,
      LD3: scrub_data?.finalConfig?.LD3 || 0,
      LD48FQA: scrub_data?.finalConfig?.LD48FQA || 0,
    },
    workarea: sortedWorkareaKeys,
    workareaData: workarea,
    summary: scrub_data?.summary || '',
    summaryRows: scrub_data?.summaryRows || [{
      awb_no: '',
      location: '',
      delay: 0,
      pri: '',
      prod_code: '',
      yesNo: 'No',
      builtUlds: '',
      comments: '',
    }],
    user: scrub_data?.user || '',
    date: scrub_data?.date || '',
  }
}

export default getScrubData
